const MuiTextFieldOverrides = {
  MuiInput: {
    styleOverrides: {
      root: _ref => {
        let {
          theme,
          ownerState
        } = _ref;
        return {
          ...theme.typography.body01,
          width: '100%',
          height: 'auto',
          backgroundColor: ownerState.inputProps?.background === 'paper' ? theme.palette.background.paper : theme.palette.background.default,
          input: {
            padding: theme.spacing(1.25, 1.5)
          },
          ':before, :after': {
            borderBottomWidth: '2px',
            borderBottomStyle: 'solid'
          },
          ':before': {
            borderColor: theme.palette.divider
          },
          ':after': {
            borderColor: theme.palette.gray80
          },
          '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: `2px solid  ${theme.palette.text.disabled}`
          },
          '&.Mui-disabled, :hover.Mui-disabled': {
            backgroundColor: theme.palette.gray20,
            ':before, :after': {
              border: 'none'
            }
          },
          '&.MuiInputBase-adornedStart': {
            '& .MuiSvgIcon-root': {
              margin: theme.spacing(0, 1)
            },
            input: {
              paddingLeft: 0
            }
          },
          '&.MuiInputBase-adornedEnd': {
            '& .MuiSvgIcon-root': {
              margin: theme.spacing(0, 1)
            },
            '& button .MuiSvgIcon-root': {
              margin: 0
            },
            input: {
              paddingRight: 0
            }
          }
        };
      },
      multiline: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          textarea: {
            padding: theme.spacing(1, 1.5)
          }
        };
      }
    }
  },
  MuiTextField: {
    defaultProps: {
      variant: 'standard',
      fullWidth: true
    },
    styleOverrides: {
      root: _ref3 => {
        let {
          theme
        } = _ref3;
        return {
          input: {
            ...theme.typography.body01,
            padding: theme.spacing(1.25, 1.5),
            color: theme.palette.text.primary,
            height: 'auto'
          },
          '.MuiInput-underline': {
            marginTop: 0
          },
          '.MuiFormLabel-root.Mui-disabled': {
            color: theme.palette.text.primary
          }
        };
      }
    }
  }
};

export { MuiTextFieldOverrides };
